import React, { useRef, useEffect } from "react";
import { Main } from "./Main.jsx";
import { Menu } from "./Menu.jsx";
import { Projects } from "./Projects/Projects.jsx";
import useScrollToTarget from "./hooks/ScrollToTarget.jsx";
import { Skills } from "./Skills.jsx";
import { Education } from "./Education.jsx";
import { HireMe } from "./HireMe.jsx";

export const LandingPage = () => {
    const myWorkRef = useRef(null);
    const skillsRef = useRef(null);
    const educationRef = useRef(null);
    const hireMeRef = useRef(null);

    const { addTarget, removeTarget, scrollToTarget } = useScrollToTarget([]);

    // Register the target references when the component mounts
    useEffect(() => {
        const addTargetCallback = (id, ref) => addTarget(id, ref);
        const removeTargetCallback = (id) => removeTarget(id);

        addTargetCallback("MyWork", myWorkRef);
        addTargetCallback("Skills", skillsRef);
        addTargetCallback("Education", educationRef);
        addTargetCallback("HireMe", hireMeRef);

        return () => {
            removeTargetCallback("MyWork");
            removeTargetCallback("Skills");
            removeTargetCallback("Education");
            removeTargetCallback("HireMe");
        };
    }, []); // Empty dependency array

    return (
        <div className="Landing-Page">
            <div className="First">
                <span className="cloud1"></span>
                <span className="cloud2"></span>
                <span className="cloud3"></span>
                <span className="cloud4"></span>
                <Menu scrollToTarget={scrollToTarget} />
                <Main scrollToTarget={scrollToTarget} />
            </div>
            <div className="Second">
                <Projects myWorkRef={myWorkRef} />
            </div>
            <div className="Third">
                <Skills skillsRef={skillsRef} />
            </div>
            <div className="Fourth">
                <Education educationRef={educationRef} />
            </div>
            <div className="Fifth">
                <HireMe hireMeRef={hireMeRef} />
            </div>
        </div>
    );
};
